import { render, staticRenderFns } from "./PromotionsChange.vue?vue&type=template&id=1a64d621&"
import script from "./PromotionsChange.vue?vue&type=script&lang=ts&"
export * from "./PromotionsChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports